import i18n from '../../../i18n';

const getRelatedTyresApi = async (ean, dimension, language = null) => {
  const lang = language || i18n.language || 'en';
  const query = `
    query GetRelatedTyres {
      getProductLineListing(
        filter: "{\\"query\\": {\\"dimension_metric\\": \\"${dimension}\\", \\"ean\\": {\\"$ne\\": \\"${ean}\\"}}}"
        first: 4
        defaultLanguage: "${lang}"
      ) {
        edges {
          node {
            artNo11Digit
            productName
            dimensionMetric
            season
            loadSpeedIndex
            mainImage {
              fullpath
            }
            singleBrandKey {
              ... on object_Brand {
                name
              }
            }
            marketingText
          }
        }
      }
    }
  `;

  try {
    const response = await fetch('/api/graphql-proxy', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({query}),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    if (result.errors) {
      console.error('GraphQL errors:', result.errors);
      throw new Error(result.errors[0].message);
    }

    return result.data.getProductLineListing.edges.map((edge) => edge.node);
  } catch (error) {
    console.error('API call failed:', error.message);
    throw error;
  }
};

export default getRelatedTyresApi;
